import React from 'react';

const RadioGroup = ({ label, name, options, onChange, disabled, FormDataValue, UserPreferencesValue }) => {

  const isSelectedValue = (selectedValue) => {
    return FormDataValue
      ? selectedValue === FormDataValue
      : selectedValue === UserPreferencesValue;
  }

  return (
    <div className="form__field">
      <div className="radio_input">
        <span className="radio_input__label">{label}</span>
        <ul className="radio_input__list">
          {options.map(option => (
            <li key={`${name}-${option.value}`} className="radio_input__list_item">
              <label className="radio_input__label">
                <input
                  type="radio"
                  className="radio_input__field"
                  name={name}
                  value={option.value}
                  checked={isSelectedValue(option.value)}
                  onChange={(e) => onChange(e.target.value)}
                  disabled={disabled}
                />
                <span className="radio_input__label_text">{option.label}</span>
              </label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RadioGroup;
